import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class GetDataService {
  constructor(private http: HttpClient) { }

  getFQAs(fqaKey: string) {
    return firstValueFrom(
      this.http.get(
        `${environment.front.href}/assets/pages-data/fqas/${fqaKey}.json`,
        {
          headers: {
            'Cache-Control': 'public, max-age=3600',
          },
        },
      ),
    );
  }

  getSEOMetaData(fqaKey: string) {

    return firstValueFrom(
      this.http.get(
        `${environment.front.href}/assets/pages-data/seo/${fqaKey}.json`,
        {
          headers: {
            'Cache-Control': 'public, max-age=3600',
          },
        },
      ),
    );
  }
}
